module.exports = __webpack_public_path__ + "img/adobe-marketing-cloud.22bf3f26.svg";